<!--当广告位是开机全屏时的素材组件-->
<template>
  <div class="uploadImg">
    <div class="sig_pic">
      <span class="addMat" :class="{disableCus:pageType==='read'}" @click="addMat(pageType==='read')">增加素材</span>
      <div class="materialBox" v-for="(item,index) in materialGroup[pic_type]">
        <p class="mat_item clearfix">
          <label>广告标题</label>
          <input type="text"
                 class="addTitle"
                 v-model="item.title" @keyup="titleLen(index)"
                 :maxlength="pic_type===1?20:35"
                 @blur="titleBlur(index)">
          <span class="wordLimit" v-if="titOver">输入的内容不能超过{{pic_type===1?20:35}}个字符！</span>
        </p>
        <p class="mat_item">
          <label>素材上传</label>
          <span class="uploadBtn">上传素材
            <!--Single&Big picture upload-->
            <input type="file"
                   accept="image/jpg,image/jpeg,image/png"
                   @change="onFileChange($event,index,'add')"
                   ref="fileBox"
                   :disabled="pageType==='read'"
                   :class="{disableCus:pageType==='read'}"
                   v-if="pic_type===0||pic_type===2">
            <!--Multiple pictures upload-->
            <input type="file"
                   accept="image/jpg,image/jpeg,image/png"
                   @change="onFileChange($event,index,'add')"
                   v-if="pic_type===1"
                   ref="fileBox"
                   :class="{disableCus:pageType==='read'}"
                   :disabled="pageType==='read'"
                   multiple>
          </span>
          <span class="typeLimit">只能上传JPG、JPEG、PNG图片，大小不超过150K</span>
        </p>
        <label class="mt30">素材预览</label>
        <div class="picBox clearfix" :class="{h270:pic_type===1}">
          <span class="del_mar" v-if="index>0&&pageType!=='read'" @click="deleteMat(index,item['group'])">删除素材</span>
          <p class="title1" v-if="pic_type===1||pic_type===2">{{item.title}}</p>
          <p class="picInfo fl" v-for="(pic, picIndex) in item.files" :class="{mr19:pic_type===1,w469:pic_type===2}">
            <!--Single picture type=0 -->
            <a :href="pic.path" target="_blank" v-if="pic_type===0">
              <img :src="pic.path" alt="">
              <span class="shadow" :class="{bg:pic.code==='0',noBg:pic.code==='1'}">
                  <b :class="{redWord: pic.code==='0'}">{{pic.initState?'Image':(pic.code==='0'?'尺寸错误！':'')}}</b>
                  <i class="icon iconfont matchIcon"
                     :class="{'icon-wrong':pic.code==='0','icon-right':pic.code==='1'&&!pic.initState}"></i>
                </span>
            </a>
            <!--Multiple pictures type=1 -->
            <a :href="pic.path" target="_blank" v-if="pic_type===1">
              <img :src="pic.path" alt="">
              <span class="shadow" :class="{bg:pic.code==='0',noBg:pic.code==='1'}">
                  <b :class="{redWord: pic.code==='0'}">{{pic.initState?'Image':(pic.code==='0'?'尺寸错误！':'')}}</b>
                  <i class="icon iconfont matchIcon"
                     :class="{'icon-wrong':pic.code==='0','icon-right':pic.code==='1'&&!pic.initState}"></i>
                </span>
            </a>
            <!--Big picture type=2-->
            <a :href="pic.path" target="_blank" v-if="pic_type===2" class="bigImg">
              <img :src="pic.path" alt="">
              <span class="shadow" :class="{bg:pic.code==='0',noBg:pic.code==='1'}">
                  <b :class="{redWord: pic.code==='0'}">{{pic.initState?'Image':(pic.code==='0'?'尺寸错误！':'')}}</b>
                  <i class="icon iconfont matchIcon"
                     :class="{'icon-wrong':pic.code==='0','icon-right':pic.code==='1'&&!pic.initState}"></i>
                </span>
            </a>
            <span class="replace">替换<input type="file"
                                           @change="onFileChange($event,index,picIndex,pic['id'])"
                                           ref="inputFileRep"></span>
            <span class="pic_size" :class="{displayBlock: pic_type===2}">{{pic.size}}</span>
          </p>
          <p class="title fl" v-if="pic_type===0">{{item.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      addNum: 1,
      titOver: false,
      materialGroup: [
        [
          {
            title: '',
            files: [
              { path: '', size: '', code: '', sizeid: '', initState: 1 }
            ]
          }
        ],
        [
          {
            title: '',
            files: [
              { path: '', size: '', code: '', sizeid: '', initState: 1 },
              { path: '', size: '', code: '', sizeid: '', initState: 1 },
              { path: '', size: '', code: '', sizeid: '', initState: 1 }
            ]
          }
        ],
        [
          {
            title: '',
            files: [
              { path: '', size: '', code: '', sizeid: '', initState: 1 }
            ]
          }
        ]
      ],
      lastmaterialGroup: {}
    };
  },
  props: {
    pic_type: {
      type: Number,
      default: 1
    },
    materialSize: {
      type: Array,
      defalut: []
    },
    matGroupData: {
      type: Array,
      default: () => {
        return [
          [
            {
              title: '',
              files: [
                { path: '', size: '', code: '', sizeid: '', initState: 1 }
              ]
            }
          ],
          [
            {
              title: '',
              files: [
                { path: '', size: '', code: '', sizeid: '', initState: 1 },
                { path: '', size: '', code: '', sizeid: '', initState: 1 },
                { path: '', size: '', code: '', sizeid: '', initState: 1 }
              ]
            }
          ],
          [
            {
              title: '',
              files: [
                { path: '', size: '', code: '', sizeid: '', initState: 1 }
              ]
            }
          ]
        ];
      }
    },
    clearMaterial: {
      type: Boolean,
      default: false
    },
    validMaterial: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: ''
    },
    advertiseId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      uploadMaterial: 'uploadMaterial',
      delComMaterial: 'delComMaterial',
      delMatGroup: 'delMatGroup'
    })
  },
  created () {
    if (this.matGroupData) {
      let o = {};
      o.matGroupData = this.matGroupData;
      if (JSON.stringify(o) !== JSON.stringify(this.lastmaterialGroup)) {
        this.lastmaterialGroup = o;
        this.matGroupData.forEach((v, i) => {
          this.materialGroup.splice(i, 1, v);
        });
      }
    }
  },
  methods: {
    // 验证弹窗
    validBox (info) {
      this.$confirm(info, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      });
    },
    validInfo () {
      /*
         * 最后一组素材的验证
         * 标题不能为空
         * 图片个数为1或为3
         * 尺寸不匹配的 重新上传活替换
         * */
      let currMaterial = this.materialGroup[this.pic_type];
      let lastMaterial = currMaterial[currMaterial.length - 1];
      let noMatch;
      let noImg;
      if (lastMaterial.title === '') {
        this.validBox('请输入标题!');
        return true;
      }
      noImg = lastMaterial.files.some((v, i) => {
        return v.path === '';
      });
      if (noImg) {
        this.validBox('请上传素材!');
        return true;
      }
      noMatch = lastMaterial.files.some((v, i) => {
        return v.code === '0';
      });
      if (noMatch) {
        this.validBox('请替换尺寸不匹配的素材!');
        return true;
      }
    },
    // 添加素材
    addMat (disableCode) {
      if (disableCode) return;
      let flag = this.validInfo();
      if (flag) return;
      let currMaterial = this.materialGroup[this.pic_type];
      if (currMaterial.length > 4) {
        this.$message({
          showClose: true,
          message: '最多上传5组素材！',
          type: 'warning'
        });
        return false;
      }
      if (this.pic_type === 0 || this.pic_type === 2) {
        currMaterial.push({
          title: '',
          files: [
            { path: '', size: '', code: '', initState: 1 }
          ]
        });
      } else if (this.pic_type === 1) {
        currMaterial.push({
          title: '',
          files: [
            { path: '', size: '', code: '', initState: 1 },
            { path: '', size: '', code: '', initState: 1 },
            { path: '', size: '', code: '', initState: 1 }
          ]
        });
      }
    },
    // 标题字符长度限制
    titleLen (index) {
      let num = (this.pic_type === 1 ? 20 : 35);
      if (this.materialGroup[this.pic_type][index].title.length >= num) {
        this.titOver = true;
      } else {
        this.titOver = false;
      }
    },
    //
    titleBlur (index) {
      let mat = this.materialGroup[this.pic_type];
      mat.splice(index, 1, mat[index]);
    },
    // 上传图片
    onFileChange (e, matIndex, add, id) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files, matIndex, add, id);
    },
    // 过滤出满足条件的图片
    imageValid (file, imgType, imgSize1) {
      /*
         * 素材支持类型及大小限制：
         * 信息流：JPG、PNG<100K
         * */
      let fileArr = [];
      let arr = [];
      let typeArrNo = [];
      let meetArr = [];
      fileArr.slice.call(file).forEach((v, i) => {
        if (imgType.indexOf(v.type) < 0) {
          typeArrNo.push(v.name);
        } else {
          arr.push({ name: v.name, type: v.type, size: v.size });
        }
      });
      file = fileArr.slice.call(file).filter((value) => {
        return typeArrNo.indexOf(value.name) === -1;
      });
      arr.forEach((v, i) => {
        if (v.type === 'image/jpeg' || v.type === 'image/png' || v.type === 'image/jpg') {
          if (v.size >= imgSize1) {
            meetArr.push(v.name);
          }
        }
      });
      if (typeArrNo.length > 0 || meetArr.length > 0) {
        let tips = '';
        if (typeArrNo.length > 0) tips += typeArrNo.join(',') + '的格式不正确！';
        // if (meetArr.length > 0) tips += meetArr.join(',') + '的大小不正确！'
        if (meetArr.length > 0) tips = '素材大小有误，请修改！';
        this.$confirm(tips, '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          callback: () => {
          },
          type: 'error'
        });
      }
      file = fileArr.slice.call(file).filter((value) => {
        return meetArr.indexOf(value.name) === -1;
      });
      return file;
    },
    createImage (file, matIndex, add, id) {
      file = this.imageValid(file, ['image/jpg', 'image/jpeg', 'image/png'], 153600);
      if (typeof FileReader === 'undefined') {
        this.$message({
          showClose: true,
          message: '您的浏览器不支持图片上传，请升级您的浏览器！',
          type: 'warning'
        });
        return false;
      }
      let vm = this;
      let leng = file.length;
      let a = 0;
      let addIndex = 0;
      let matFile = vm.materialGroup[this.pic_type][matIndex].files;
      let mat = this.materialGroup[this.pic_type];
      vm.images = [];
      for (let i = 0; i < leng; i++) {
        let reader = new FileReader();
        reader.onload = function (e) {
          a++;
          vm.images.push(e.target.result);
          if (a === leng) {
            vm.$store.dispatch('getUploadMaterialCode', {
              file: vm.images,
              size: vm.materialSize
            }).then(() => {
              if (vm.uploadMaterial.success === 1) {
                vm.uploadMaterial.data.forEach((v, i) => {
                  for (let j = 0; j < matFile.length; j++) {
                    if (!matFile[j] || matFile[j].path === '') {
                      addIndex = j;
                      break;
                    }
                  }
                  matFile.splice(add === 'add' ? addIndex : add, 1, {
                    path: v.path,
                    size: v.size,
                    code: v.code,
                    sizeid: v.sizeid,
                    initState: 0
                  });
                });
              }
            });
            mat.splice(matIndex, 1, mat[matIndex]);
            vm.clearInput();
          }
        };
        reader.readAsDataURL(file[i]);
      }
    },
    // 清空 input[type='file']的value
    clearInput () {
      let inputFile = this.$refs.fileBox;
      inputFile.forEach((v, i) => {
        v.value = '';
      });
      //  inputFile.outerHTML = inputFile.outerHTML
    },
    // 删除素材组
    deleteMat (index, group) {
      if (!group) {
        this.materialGroup[this.pic_type].splice(index, 1);
      } else {
        this.$confirm('是否永久删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('getDelMatGroupCode', { aid: this.advertiseId, group: group }).then(() => {
            if (this.delMatGroup.success === 1) {
              this.materialGroup[this.pic_type].splice(index, 1);
              this.$message({
                showClose: true,
                message: '已删除！',
                type: 'success'
              });
            } else {
              this.$message({
                showClose: true,
                message: '删除失败！',
                type: 'error'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    // 清空素材
    clearMat () {
      let materials = this.materialGroup[this.pic_type];
      if (this.pic_type === 0 || this.pic_type === 2) {
        materials.splice(0, materials.length, {
          title: '',
          files: [
            { path: '', size: '', code: '', initState: 1 }
          ]
        });
      } else if (this.pic_type === 1) {
        materials.splice(0, materials.length, {
          title: '',
          files: [
            { path: '', size: '', code: '', initState: 1 },
            { path: '', size: '', code: '', initState: 1 },
            { path: '', size: '', code: '', initState: 1 }
          ]
        });
      }
    }
  },
  watch: {
    clearMaterial () {
      this.clearMat();
    },
    validMaterial () {
      let flag = this.validInfo();
      if (flag) {

      }
    },
    materialGroup () {
      this.$emit('materialChange', {
        materials: this.materialGroup,
        index: this.pic_type
      });
    },
    matGroupData () {
      let o = {};
      o.matGroupData = this.matGroupData;
      if (JSON.stringify(o) !== JSON.stringify(this.lastmaterialGroup)) {
        this.lastmaterialGroup = o;
        this.matGroupData.forEach((v, i) => {
          this.materialGroup.splice(i, 1, v);
        });
      }
    }
  }
};
</script>
